import { render, staticRenderFns } from "./opilase_kysimused.vue?vue&type=template&id=2d67cbb4&"
import script from "./opilase_kysimused.vue?vue&type=script&lang=js&"
export * from "./opilase_kysimused.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports